<script>
	import { scaleAdOnHover, startAd } from '../../../../share/ads';
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	let ads = {
		// KAT-P0117-Obsternte-300x600-Margaret-adform
		kathiMargaret: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/05.aktionswebsites/Margaret-300x600/backup.webp',
			imageAltText: 'Kathi - Margaret - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/05.aktionswebsites/Margaret-300x600/index.html',
			playTimeMs: 12000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false
		},
		// KAT-P0117-Obsternte-300x600-Sybille-adform
		kathiSybille: {
			element: false,
			fallbackImgUrl: './../commercial/10.Appetit_Digitalisieren/05.aktionswebsites/Sybille-300x600/backup.webp',
			imageAltText: 'Kathi - Sybille - interactive Ad',
			iframeIndexUrl: './../commercial/10.Appetit_Digitalisieren/05.aktionswebsites/Sybille-300x600/index.html',
			playTimeMs: 12000,
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false
		}
	}

	let div_kathi;

	onMount(() => {
		jumpByAnchor(div_kathi);
	});
</script>

<div bind:this={div_kathi} id="kathi">
	<div class="flex structure marginbox">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Kathi Gewinnspiel - Ad-Design" src="./../img/10.Appetit_Digitalisieren/05.aktionswebsites/Kathi_Gewinnspiel.webp">
			</div>
			
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("10.05.01_h2")}</h2>
					<p class="caption">{getText("10.05.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex row structure-2-1">
				<div class="flex element halfpage">
					<!-- Beginning - Ad: kathiMargaret -->
					<div bind:this={ads.kathiMargaret.element} class="content">
						{#if ads.kathiMargaret.playing}
							<div class="commercial" class:playing={ads.kathiMargaret.playing}>
								<!-- PLAYING -->
								<iframe scrolling="no" src={ads.kathiMargaret.iframeIndexUrl}
										style="--bg-image: url('{ads.kathiMargaret.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						{:else}
							<div use:scaleAdOnHover class="commercial" class:playing={ads.kathiMargaret.playing} on:click={() => startAd(ads.kathiMargaret, () => ads = ads)}>
								<!-- NOT PLAYING -->
								<img loading="lazy" alt={ads.kathiMargaret.imageAltText} src={ads.kathiMargaret.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.kathiMargaret.imageAltText}" class="playbutton"></button>
							</div>
						{/if}
					</div>
					<!-- End - Ad -->
				</div>
				
				<div class="flex element halfpage">
					<!-- Beginning - Ad: kathiSybille -->
					<div bind:this={ads.kathiSybille.element} class="content">
						{#if ads.kathiSybille.playing}
							<div class="commercial" class:playing={ads.kathiSybille.playing}>
								<!-- PLAYING -->
								<iframe scrolling="no" src={ads.kathiSybille.iframeIndexUrl}
										style="--bg-image: url('{ads.kathiSybille.fallbackImgUrl}')"
										on:load={(e) => e.target.setAttribute('loaded', 'true')}/>
							</div>
						{:else}
							<div use:scaleAdOnHover class="commercial" class:playing={ads.kathiSybille.playing} on:click={() => startAd(ads.kathiSybille, () => ads = ads)}>
								<!-- NOT PLAYING -->
								<img loading="lazy" alt={ads.kathiSybille.imageAltText} src={ads.kathiSybille.fallbackImgUrl}/>
								<button aria-label="play Ad - {ads.kathiSybille.imageAltText}" class="playbutton"></button>
							</div>
						{/if}
					</div>
					<!-- End - Ad -->
				</div>
			</div>
			
			<div class="flex structure-2-2">
				<div class="flex element">
					<img loading="lazy" alt="Obsternte-Fireplace - Ad-Design"
						 src="./../commercial/10.Appetit_Digitalisieren/05.aktionswebsites/Obsternte-Fireplace/backup.webp">
				</div>
			</div>
		</div>
	</div>
	
	<div class="structure-3 marginbox">
		<img loading="lazy" alt="Kathi-Email-Design"
			 src="./../img/10.Appetit_Digitalisieren/05.aktionswebsites/Kathi_Email_confirmation.webp">
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	.commercial {
		position: relative;
		width: 100%;
		height: auto;
		aspect-ratio: .5;
		display: flex;
		align-items: center;

		:global(.greyOverlay) {
			top: 50%;
			transform: translateY(-50%);
		}
		:global(img), :global(iframe) {
			height: 100% !important;
			width: auto !important;
		}
	}

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.flex {
		display: flex;
		box-sizing: border-box;
	}
	
	.row {
		flex-flow: row wrap;
	}
	
	.col {
		flex-flow: column wrap;
	}
	
	.element {
		min-width: 100px;
	}
	
	.content {
		flex: 1 100%;
	}
	
	.structure {
		flex-flow: row wrap;

		@include for-desktop-up {
			flex-flow: row nowrap;
		}
	}
	
	.structure-1 {
		flex-shrink: 1;
		width: auto;
		margin-bottom: $media-gap;
		
		@include for-tablet-landscape-up {
			margin-top: 0;
			margin-right: $media-gap;

			.element:last-of-type {
				justify-content: end;
			}
		}

		@include for-desktop-up {
			flex: 749;
		}

		.element:first-of-type {
			width: 100%;
			margin-bottom: $media-gap;
		}
	}
	
	.structure-2 {
		flex-shrink: 0;
		width: 100%;
		/*justify-content: space-evenly;*/
		margin-bottom: $spacing-mobile;
		
		@include for-tablet-landscape-up {
			width: 610px;
			justify-content: start;
		}

		@include for-desktop-up {
			width: auto;
			flex: 609;
		}
	}
	
	.structure-3 {
		img {
			box-shadow: 0 2px 1.5em grey;
		}
	}
	
	.structure-2-1 {
		justify-content: center;
		margin-bottom: $media-gap;
		gap: $media-gap;

		@include for-tablet-landscape-up {
			justify-content: flex-start;
			flex-flow: row nowrap;
		}
	}

	.halfpage iframe {
		width: 100%;
		height: 100%;
	}

	@include for-desktop-up {
		.structure-2-2 {
			display: contents;

			.element {
				display: contents;

				img {
					height: fit-content;
				}
			}
		}
	}
	
	iframe {
		border: none;
		background-image: var(--bg-image);
		background-size: cover;
	}

	:global(iframe[loaded]) {
		background-image: none !important;
	}
	
	.text {
		margin-bottom: $media-gap;
		
		@include for-tablet-landscape-up {
			max-width: 70%;
		}
	}
</style>
